




































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import Paging from '@/shared/components/Paging.vue';
import { WithdrawalHistory } from '@/models/withdrawal-history';
import creditServices from '@/services/credit-services';

@Component({
    components: {
        Paging,
        Loading
    }
})
export default class WithdrawalHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listWithdrawalHistories: WithdrawalHistory[] = [];
    private isLoading = false;

    private async created() {
        eventBus.$on(APP_CONFIG.eventBusAction.reloadWithdrawalHistories, () => {
            this.pageSettings.pageIndex = 1;
            this.loadHistories();
        });
        this.loadHistories();
    }

    private async loadHistories() {
        this.isLoading = true;
        const result = await creditServices.withdrawalHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, '');
        if (result && result.status === 200) {
            const rawList = Array.isArray(result.data.data) ? result.data.data : (result.data.data && result.data.data.list ? result.data.data.list : []);
            this.pageSettings.total = result.data.total !== undefined ? result.data.total : ((result.data.data && result.data.data.total) || 0);
            this.listWithdrawalHistories = rawList.map((item: any) => {
                const history: WithdrawalHistory = {
                    amount: item.Amount,
                    createdBy: item.CreatedBy || item.CreateBy,
                    createdDate: item.CreatedDate || item.CreateDate,
                    id: item.ID,
                    status: item.Status,
                    userName: item.Username || item.UserName,
                    statusDetail: (DATA.statusWithdrawal || []).find((x: any) => x.value === item.Status) || { name: 'Chờ duyệt', color: '#f59e0b', textColor: '#fff' }
                };
                return history;
            });
        }
        this.isLoading = false;
    }

    private onChangePage(page: number) {
        this.pageSettings.pageIndex = page;
        this.loadHistories();
    }
}
